import { uploadPhoto } from "../services/CertificateService";


const MAX_WIDTH = 1920;
const MAX_HEIGHT = 1080;

export const dummyRequest = ({ file, onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};

export  const checkResolution = async(file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new window.Image();

        img.onload = () => {
          const { width, height } = img;
          console.log(width,height)
          if (width <= MAX_WIDTH && height <= MAX_HEIGHT) {
            resolve(true);
          } else {
            resolve(false);
          }
        };

        img.onerror = () => {
          resolve(false);
        };

        img.src = e.target.result;
      };

      reader.onerror = () => {
        resolve(false);
      };

      reader.readAsDataURL(file);
    });
  };

export const uploadAndReturnUrl = async (image) => {
  let formData = new FormData();
  let urlResponse;
  if (image) {
    formData.append("file", image);
    urlResponse = await uploadPhoto(formData);
  }
  return urlResponse?.url ? urlResponse.url : "";
};

export const convertFormDataToObject = (formDataArray) => {
  return formDataArray
    .map((item) => {
      if (item.name[0].includes("image_url")) {
        return {
          [item.name[0]]: item?.value?.file?.originFileObj ?? "",
        };
      } else {
        return {
          [item.name[0]]: item.value ?? "",
        };
      }
    })
    .reduce((acc, curr) => Object.assign(acc, curr), {});
};

export const transformImageFileToUrlObject = async (formData) => {
  for (const key of Object.keys(formData)) {
    if (key.includes("image_url")) {
      formData[key] = formData[key] ? await uploadAndReturnUrl(formData[key]) : null;
    }
  }
  return formData;
};

export const getLocalISODate = () => {
  const now = new Date();
  const offset = now.getTimezoneOffset(); // difference in minutes from UTC
  const local = new Date(now.getTime() - offset * 60 * 1000);

  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const dayName = days[local.getDay()];
  const date = local.getDate();
  const monthName = months[local.getMonth()];
  const year = local.getFullYear();

  // Add ordinal suffix (st, nd, rd, th)
  const getOrdinal = (n) => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  return `${dayName}, ${date}${getOrdinal(date)} ${monthName} ${year}`;
};

 export const getColor = (rating) => {
    switch (rating) {
      case 1:
        return "#BD1B04"
      case 2:
        return "#BD5204"
      case 3:
        return "#D7C200"
      case 4:
        return "#8DA400"
      case 5:
        return "#0B8617"
      default:
        return "#0B8617"
    }
  }
